export function shouldClearFileDragging(
  relatedTarget: unknown,
  contains: (target: unknown) => boolean,
): boolean {
  return (
    relatedTarget === null ||
    relatedTarget === undefined ||
    !contains(relatedTarget)
  );
}
